'use strict';

import { camelize, camelizeKeys } from 'humps';
import mapKeys from './mapKeys';
import mapValues from 'lodash/object/mapValues';

function camelizeAction(action) {
  const camelized = camelizeKeys(action);

  // Don't camelize entity keys, but camelize everything inside:
  // action.response.entities.humptyDumpties['vorpal-jabberwock'].snarkCount

  if (action.response && action.response.entities) {
    camelized.response.entities = mapValues(
      mapKeys(action.response.entities, camelize),
      entityBag => mapValues(entityBag, camelizeKeys)
    );
  }

  return camelized;
}

export default camelizeAction;



/** WEBPACK FOOTER **
 ** ./utils/camelizeAction.js
 **/